import * as types from "../mutation-types";
import axios from "../../http.js";

const state = {
  login_state: false,
  token: null
};

const getters = {};

const actions = {
  login({ commit, state }) {
    axios
      .get("../../static/test1.json")
      .then(function(response) {
        state.login_state = true;
        var token = response.data.test;
        commit(types.LOGIN, { token });
      })
      .catch(function(error) {
    
      });
  }
};

const mutations = {
  [types.LOGIN]: (state, { token }) => {
    sessionStorage.setItem("token", token);
    //state.token=token;
  },
  [types.LOGIN_OUT]: state => {
    sessionStorage.removeItem("token");
    //state.token = null
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};
